import styled from "styled-components"

import { spacing, Text } from "@minuthq/meatball-ui-react"

import { MCard } from "src/ui/MCard/MCard"

export function EmptyStateCard({
  image: Image,
  title,
  subtitle,
}: {
  image: React.FC<React.SVGProps<SVGSVGElement>>
  title: string
  subtitle: React.ReactNode
}) {
  return (
    <MCard border boxShadow={false}>
      <CardContent>
        <ImageBox>
          <Image />
        </ImageBox>
        <TextWrapper>
          <Text variant="heading3" color="primary">
            {title}
          </Text>
          {subtitle}
        </TextWrapper>
      </CardContent>
    </MCard>
  )
}

const ImageBox = styled.div`
  width: 64px;
  height: 64px;
`

const CardContent = styled.div`
  display: flex;
  flex-direction: row;
  gap: ${spacing.L};
  align-items: center;
`
const TextWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${spacing.XS2};
`
